import React, { Fragment } from 'react';
import { StaticQuery, graphql } from 'gatsby';

import { Block } from '../common';
import Header, { headerHeight } from '../Header';
import Footer from '../Footer';
import {
  getContentfulFlavour,
  mapFlavourDataStructure,
} from '../../modules/flavours';
import Provider from '../../stores/Provider';
import { getMenuLinks } from '../../modules/flavours';

const SiteWrapper = ({ children, withStore = true, withDefaultHeader }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulFlavour {
          edges {
            node {
              identifier
              default
              extReference
              orderedDetail {
                deets {
                  id
                  title
                  images {
                    id
                    title
                    fluid(maxWidth: 1500, maxHeight: 600) {
                      ...GatsbyContentfulFluid
                    }
                  }
                  mainBody {
                    childContentfulRichText {
                      html
                    }
                  }
                  prop {
                    id
                    snippetText
                    image {
                      id
                      title
                      fluid(maxWidth: 800, maxHeight: 500) {
                        ...GatsbyContentfulFluid
                      }
                    }
                    longText {
                      childContentfulRichText {
                        html
                      }
                    }
                  }
                }
              }
              orderedHooks {
                hooks {
                  id
                  image {
                    id
                    title
                    fullSize: fluid(maxWidth: 800, maxHeight: 500) {
                      ...GatsbyContentfulFluid
                    }
                    thumbnail: fixed(width: 100, height: 100) {
                      ...GatsbyContentfulFixed
                    }
                  }
                  longText {
                    childContentfulRichText {
                      html
                    }
                  }
                }
              }
              prop {
                id
                snippetText
                image {
                  id
                  title
                  fluid(maxWidth: 800, maxHeight: 500) {
                    ...GatsbyContentfulFluid
                  }
                }
                longText {
                  childContentfulRichText {
                    html
                  }
                }
              }
              personalisation {
                configuration {
                  internal {
                    content
                  }
                }
              }
            }
          }
        }
        site {
          siteMetadata {
            flavour
          }
        }
      }
    `}
    render={({
      site: {
        siteMetadata: { flavour },
      },
      allContentfulFlavour,
    }) => {
      const selectedFlavour = mapFlavourDataStructure(
        getContentfulFlavour(allContentfulFlavour, flavour)
      );
      console.log({ selectedFlavour });
      const Wrapper = withStore ? Provider : Fragment;
      return (
        <Wrapper>
          <Block
            style={Object.assign(
              {},
              { minHeight: '100vh', height: '100%' },
              withDefaultHeader ? { paddingTop: headerHeight } : null
            )}
          >
            {withDefaultHeader && (
              <Header headerLinks={getMenuLinks(selectedFlavour)} isSticky />
            )}
            <Block>{children({ flavour: selectedFlavour })}</Block>
            <Block noFlex>
              <Footer />
            </Block>
          </Block>
        </Wrapper>
      );
    }}
  />
);

export default SiteWrapper;
